import React, { useEffect, useRef, useState } from "react";
import { numberOnly } from "../bin/common";
import { useMutation } from "@tanstack/react-query";
import { getUserInfo, modifyUserInfo, smsCert, smsSend } from "../library/api";
import axiosInstance from "../library/axios-index";
import { ChromePicker } from "react-color";
import styled from "@emotion/styled";
import { useRecoilValue } from "recoil";
import { verifyInfoState } from "../library/recoil/atoms/verifyInfoState.js";
const Payment = () => {
  const token = localStorage.getItem("admin_token");
  const verifyInfo = useRecoilValue(verifyInfoState);
  const [modalOpen, setModalOpen] = useState(false);
  const [pickerOpen, setPickerOpen] = useState({
    bgColorPink: false,
    iconColorPink: false,
  });
  const [bankOption, setBankOption] = useState([]);
  const [valueCheck, setValueCheck] = useState({
    phoneNum: false,
    certKey: false,
  });
  const [value, setValue] = useState({});
  const [phone, setPhone] = useState("");

  const bankbookImgRef = useRef();
  const idImgRef = useRef();
  const logoPhotoRef = useRef();
  const bizRegPhotoRef = useRef();
  const pickerRef = useRef();
  const regEmail =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
  // 퍄트너스 회원 정보 가져오기
  const { mutate: getUserInfoMutate, data: getUserInfoData } = useMutation({
    mutationFn: getUserInfo,
    mutationKey: ["getUserInfo"],
    onSuccess: (data) => {
      const items = {
        email: data?.email_addr,
        name: !data?.partners_nm ? "" : data?.partners_nm,
        phoneNum: data?.phone_num,
        bankNm: !data?.bank_nm ? "" : data?.bank_nm,
        bankAccount: !data?.bank_acct ? "" : data?.bank_acct,
        bankUserNm: !data?.bank_user_nm ? "" : data?.bank_user_nm,
        certNum: "",
        bankPhoto: data?.bank_photo,
        idPhoto: data?.id_photo,
        corpNm: data?.corp_nm || "",
        colorCd: data?.color_cd || "#F7FAFC",
        iconColorCd: data?.icon_color_cd || "#F7FAFC",
        logoPhoto: data?.logo_photo || "",
        bizRegPhoto: data?.biz_reg_photo || "",
        franchisorYn: data?.franchisor_yn || "N",
      };

      setValue(items);
    },
    onError: (error) => {
      if (error.response.data.code !== 401) {
        alert(error.response.data.message);
      }
      throw error;
    },
  });

  // 퍄트너스 회원 정보 수정하기
  const { mutate: modifyUserInfoMutate } = useMutation({
    mutationFn: modifyUserInfo,
    mutationKey: ["modifyUserInfo"],
    onSuccess: (data) => {
      if (data.done) {
        alert("결제정보가 수정되었습니다");
        getUserInfoMutate();
        // setUserInfo(items);
      }
    },
    onError: (error) => {
      if (error.response.data.code !== 401) {
        alert(error.response.data.message);
      }
      throw error;
    },
  });

  // 문자 전송
  const { mutate: smsSendMutate } = useMutation({
    mutationFn: smsSend,
    mutationKey: ["smsSend"],
    onSuccess: (data) => {
      if (data.done) {
        alert("인증번호가 전송했습니다");
        setValueCheck((prevState) => ({ ...prevState, phoneNum: true }));
        setTimeout(() => {
          if (valueCheck.certKey === false) {
            setValue((prevState) => ({ ...prevState, certNum: "" }));
            setValueCheck((prevState) => ({
              ...prevState,
              phoneNum: false,
              certKey: false,
            }));
          }
        }, 180000);
      }
    },
    onError: (error) => {
      if (error.response.data.code !== 401) {
        alert(error.response.data.message);
      }
      throw error;
    },
  });

  // 문자 인증번호 인증
  const { mutate: smsCertMutate } = useMutation({
    mutationFn: smsCert,
    mutationKey: ["smsCert"],
    onSuccess: (data) => {
      if (data.done) {
        alert("인증이 완료 되었습니다");
        setValueCheck((prevState) => ({ ...prevState, certKey: true }));
        return;
      }
    },
    onError: (error) => {
      alert(error.response.data.message);
      if (error.response.data.code === 406) {
        setValue((prevState) => ({ ...prevState, certNum: "" }));
        // setValueCheck(prevState => ({...prevState, phoneNum: false, certKey: false}));
      }
      throw error;
    },
  });

  const handlePhoneNum = (event) => {
    // if (value.phoneNum !== userInfo?.phone_num) {
    event.preventDefault();
    if (!phone) {
      alert("휴대폰 번호를 입력해주세요");
      return;
    }
    if (!valueCheck.phoneNum) {
      alert("휴대폰 번호를 인증해주세요");
      return;
    }
    if (!value.certNum) {
      alert("인증번호를 입력해주세요");
      return;
    }
    if (value.certNum.length < 6) {
      alert("인증번호를 확인해주세요");
      return;
    }

    if (!valueCheck.certKey) {
      alert("인증번호를 인증해주세요");
      return;
    }
    setModalOpen(false);
    setValue((prevState) => ({ ...prevState, phoneNum: phone }));
    // }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!value.name) {
      alert("이름을 입력해주세요");
      return;
    }

    if (!value.email) {
      alert("이메일을 입력해주세요");
      return;
    }
    if (!regEmail.test(value.email)) {
      alert("이메일이 올바르지 않습니다.");
      return;
    }
    if (!value.phoneNum) {
      alert("휴대폰 번호를 입력해주세요");
      return;
    }

    if (!value.bankNm) {
      alert("은행를 선택해주세요");
      return;
    }
    if (!value.bankAccount) {
      alert("계좌번호를 입력해주세요");
      return;
    }
    if (!value.bankUserNm) {
      alert("예금주명을 입력해주세요");
      return;
    }
    if (value?.franchisorYn === "Y") {
      if (!value?.corpNm) {
        alert("회사명을 입력해주세요");
        return;
      }
      if (!value?.logoPhoto) {
        alert("로고를 업로드해주세요");
        return;
      }
      if (!value?.bizRegPhoto) {
        alert("사업자등록증을 업로드해주세요");
        return;
      }
    } else {
      value.corpNm = null;
      value.logoPhoto = null;
      value.bizRegPhoto = null;
      value.colorCd = null;
      value.iconColorCd = null;
    }

    delete value.certNum;

    modifyUserInfoMutate(value);
  };

  useEffect(() => {
    (async () => {
      const bankResp = await axiosInstance.post(`/code/codeList`, {
        lang: "ko",
        uuid: "string",
        token,
        mst_cd_id: "M0010",
      });
      setBankOption(
        bankResp.data.result.map((e) => {
          return { value: e.dtl_cd_nm, label: e.dtl_cd_nm };
        })
      );
    })();
    getUserInfoMutate();
  }, []);

  const handleUploadFile = async (formName, e) => {
    const formData = new FormData();
    // return;
    formData.append("files", e[0]);

    const {
      data: { result },
    } = await axiosInstance.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const img = result[0];

    setValue((prevState) => ({
      ...prevState,
      [formName]: img,
    }));
  };

  const handleDeleteFile = async (formName) => {
    setValue((prevState) => ({
      ...prevState,
      [formName]: "",
    }));
    //    setValue(formName, '');
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        getUserInfoData &&
        pickerRef.current &&
        !pickerRef.current.contains(event.target)
      ) {
        // 여기서 원하는 작업을 수행

        setPickerOpen({
          bgColorPink: false,
          iconColorPink: false,
        });
        setValue((prevState) => ({
          ...prevState,
          colorCd: getUserInfoData?.color_cd || "#F7FAFC",
          iconColorCd: getUserInfoData?.color_cd || "#F7FAFC",
        }));
      }
    }

    // 마운트 시 document에 이벤트 리스너 추가
    document.addEventListener("mousedown", handleClickOutside);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);

  return (
    <main className="flex-grow w-full mx-auto px-4 py-8 sm:py-12 bg-[#F7F7F7]">
      <h1 className="text-2xl sm:text-3xl font-bold text-center mt-[16px]">
        결제정보 변경
      </h1>
      <p className="text-center mt-2 mb-12">결제자 정보를 입력해 주세요.</p>

      <div className="max-w-[600px] mx-auto bg-white p-6 sm:p-12 rounded-[10px] shadow-md mb-[64px]">
        <form id="paymentForm" onSubmit={handleSubmit}>
          <div className="mb-10">
            <h2 className="font-bold mb-5">연락처를 입력해 주세요.</h2>
            <div className="border-b border-gray-300 mb-7"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
              <div>
                <label className="block text-sm mb-2">
                  이름 <span className="text-teal-500">*</span>
                </label>
                <input
                  type="text"
                  value={value?.name}
                  onChange={(e) => {
                    setValue((prevState) => ({
                      ...prevState,
                      name: e.target.value,
                    }));
                  }}
                  className="text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px]
                                focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
              </div>
              <div>
                <label className="block text-sm mb-2">
                  이메일 <span className="text-teal-500">*</span>
                </label>
                <input
                  type="email"
                  className="text-sm w-full px-3 h-9 mb-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
                  value={value?.email}
                  onChange={(e) => {
                    e.preventDefault();
                    setValue((prevState) => ({
                      ...prevState,
                      email: e.target.value,
                    }));
                  }}
                />

                {!regEmail.test(value.email) && (
                  <p className="text-red-500 text-xs">
                    이메일을 정확히 입력해주세요.
                  </p>
                )}
              </div>
            </div>
            <div>
              <label className="block text-sm mb-2">
                전화번호 <span className="text-teal-500">*</span>
              </label>
              <div className="flex gap-x-[10px] mb-2">
                <input
                  type="text"
                  placeholder="휴대폰번호"
                  maxLength="12"
                  value={value.phoneNum}
                  readOnly={true}
                  className="bg-[#dad9d9] text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
                />
                <button
                  type="button"
                  className={`w-40  text-white py-1.5 rounded-[10px] ${
                    valueCheck.phoneNum ? "bg-regal-blue" : "bg-teal-500"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setModalOpen(true);
                    //   smsSendMutate(value.phoneNum);
                  }}
                >
                  재인증
                </button>
              </div>
            </div>
          </div>

          <div>
            <h2 className="font-bold mb-5">계좌 정보를 입력해 주세요.</h2>
            <div className="border-b border-gray-300 mb-7"></div>
            <label className="block text-sm mb-2">
              은행 <span className="text-teal-500">*</span>
            </label>
            <select
              onChange={(event) =>
                setValue((prevState) => ({
                  ...prevState,
                  bankNm: event.target.value,
                }))
              }
              className="mb-5 text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
              <option
                value={!value.bankNm ? "" : value.bankNm}
                selected
                disabled
                hidden
                className="text-gray-400"
              >
                {!value.bankNm ? "선택" : value.bankNm}
              </option>
              {bankOption?.map((e) => (
                <option key={e.value} value={e.value}>
                  {e.label}
                </option>
              ))}
            </select>
            <label className="block text-sm mb-2">
              계좌번호 <span className="text-teal-500">*</span>
            </label>

            <input
              type="text"
              onChange={(event) => {
                setValue((prevState) => ({
                  ...prevState,
                  bankAccount: event.target.value,
                }));
                numberOnly(event);
              }}
              value={value?.bankAccount}
              className="text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px] mb-5 focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="숫자만 입력해주세요."
            />
            <label className="block text-sm mb-2">
              예금주명 <span className="text-teal-500">*</span>
            </label>
            <input
              type="text"
              onChange={(e) => {
                setValue((prevState) => ({
                  ...prevState,
                  bankUserNm: e.target.value,
                }));
              }}
              value={value?.bankUserNm}
              className="text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px] mb-5 focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <div className="mb-10">
            <h2 className="font-bold mb-5">정산 서류를 업로드해 주세요.</h2>
            <div className="border-b border-gray-300 mb-7"></div>
            <div className="w-full flex sm:flex-row flex-col gap-x-10 gap-y-5 ">
              <div className="w-full">
                <p className="mb-3 text-sm">주민등록증/운전면허증 </p>
                <div className="relative img-wrap h-[150px]">
                  <input
                    type="file"
                    id="fileUpload2"
                    className="hidden"
                    accept="image/*"
                    ref={idImgRef}
                    onChange={(event) => {
                      event.preventDefault();
                      handleUploadFile("idPhoto", event.target.files);
                    }}
                  />
                  <label htmlFor="fileUpload2" className="block">
                    <div className="bg-[#F5F5F5] flex flex-col justify-center items-center rounded-[4px] h-[150px] text-center cursor-pointer">
                      {value.idPhoto ? (
                        <div className="img flex items-center justify-center overflow-hidden">
                          <img
                            className=""
                            src={value.idPhoto}
                            alt="Upload file"
                          />
                          <div className="hover-wrapper">
                            <div className="upload-label">
                              <button
                                type="button"
                                onClick={(event) => {
                                  event.preventDefault();
                                  idImgRef.current.click();
                                }}
                              >
                                이미지 재업로드
                              </button>
                            </div>
                            <div
                              className="delete-label"
                              onClick={(event) => {
                                event.preventDefault();
                                handleDeleteFile("idPhoto");
                              }}
                            >
                              <button type="button">이미지 삭제</button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-2">
                          <img src="./assets/plus.svg" alt="Upload file" />
                        </div>
                      )}
                    </div>
                  </label>
                </div>
              </div>
              <div className="w-full">
                <p className="mb-3 text-sm">통장사본 </p>
                <div className="relative img-wrap h-[150px]">
                  <input
                    type="file"
                    id="fileUpload"
                    className="hidden"
                    accept="image/*"
                    ref={bankbookImgRef}
                    onChange={(event) => {
                      event.preventDefault();
                      handleUploadFile("bankPhoto", event.target.files);
                    }}
                  />
                  <label htmlFor="fileUpload" className="block">
                    <div className="bg-[#F5F5F5] flex flex-col justify-center items-center rounded-[4px] h-[150px] text-center cursor-pointer">
                      {value.bankPhoto ? (
                        <div className="img flex items-center justify-center overflow-hidden">
                          <img
                            className=""
                            src={value.bankPhoto}
                            alt="Upload file"
                          />
                          <div className="hover-wrapper">
                            <div className="upload-label">
                              <button
                                type="button"
                                onClick={(event) => {
                                  event.preventDefault();
                                  bankbookImgRef.current.click();
                                }}
                              >
                                이미지 재업로드
                              </button>
                            </div>
                            <div
                              className="delete-label"
                              onClick={(event) => {
                                event.preventDefault();
                                handleDeleteFile("bankPhoto");
                              }}
                            >
                              <button type="button">이미지 삭제</button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-2">
                          <img src="./assets/plus.svg" alt="Upload file" />
                        </div>
                      )}
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-7">
            <h2 className="font-bold mb-5">
              추천인 코드{" "}
              <em className="ml-2" style={{ fontStyle: "normal" }}>
                {verifyInfo?.partners_id}
              </em>
            </h2>
            <div className=" mb-7"></div>
          </div>
          <div className="mb-10 mt-8">
            <div className="flex items-center mb-3">
              <input
                type="checkbox"
                checked={value?.franchisorYn === "Y"}
                id="franchisorYn"
                onChange={(event) => {
                  setValue((prevState) => ({
                    ...prevState,
                    franchisorYn: event.target.checked ? "Y" : "N",
                  }));
                }}
                className="mr-2 w-4 h-4 cursor-pointer"
              />
              <label htmlFor="remember" className="text-lg font-bold">
                프랜차이즈
              </label>
            </div>
            {value?.franchisorYn === "Y" && (
              <>
                <h2 className="font-bold mb-5">
                  프랜차이즈 정보를 입력해 주세요.
                </h2>
                <div className="border-b border-gray-300 mb-7"></div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                  <div className="col-span-2">
                    <label className="block text-sm mb-2">
                      회사명 <span className="text-teal-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={value?.corpNm}
                      onChange={(e) => {
                        setValue((prevState) => ({
                          ...prevState,
                          corpNm: e.target.value,
                        }));
                      }}
                      className="text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px]
                                focus:outline-none focus:ring-2 focus:ring-teal-500"
                    />
                  </div>
                  <div className="relative">
                    <label className="block text-sm mb-2">
                      배경 컬러코드 <span className="text-teal-500">*</span>
                    </label>
                    <input
                      type="text"
                      className={`text-sm w-full cursor-pointer px-3 h-9 mb-2 border  border-gray-300 rounded-[10px] focus:outline-none focus:ring-2  focus:ring-teal-500`}
                      style={{
                        backgroundColor: value?.colorCd,
                      }}
                      readOnly
                      //   value={value?.colorCd}
                      onClick={(e) => {
                        e.preventDefault();
                        setPickerOpen((prevState) => ({
                          bgColorPink: !prevState.bgColorPink,
                          iconColorPink: false,
                        }));
                      }}
                    />
                    {pickerOpen?.bgColorPink && (
                      <ColorPickerWrapper
                        ref={pickerRef}
                        className="absolute mt-2 z-[9999]"
                      >
                        <ChromePicker
                          disableAlpha={true}
                          color={value?.colorCd}
                          onChange={(color) => {
                            setValue((prevState) => ({
                              ...prevState,
                              colorCd: color.hex,
                            }));
                          }}
                        />
                        <div className="mt-2">
                          <button
                            className=" w-[50%]   text-gray-700 py-1   transition duration-300"
                            onClick={(e) => {
                              e.preventDefault();

                              setValue((prevState) => ({
                                ...prevState,
                                colorCd: getUserInfoData?.color_cd || "#F7FAFC",
                              }));
                              setPickerOpen((prevState) => ({
                                ...prevState,
                                bgColorPink: false,
                              }));
                            }}
                          >
                            취소
                          </button>
                          <button
                            className=" w-[50%]   text-teal-500 py-1  transition duration-300"
                            onClick={(e) => {
                              e.preventDefault();
                              setPickerOpen((prevState) => ({
                                ...prevState,
                                bgColorPink: false,
                              }));
                            }}
                          >
                            완료
                          </button>
                        </div>
                      </ColorPickerWrapper>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-sm mb-2">
                      아이콘 컬러코드 <span className="text-teal-500">*</span>
                    </label>
                    <input
                      type="text"
                      className={`text-sm w-full cursor-pointer px-3 h-9 mb-2 border  border-gray-300 rounded-[10px] focus:outline-none focus:ring-2  focus:ring-teal-500`}
                      style={{
                        backgroundColor: value?.iconColorCd,
                      }}
                      readOnly
                      //   value={value?.colorCd}
                      onClick={(e) => {
                        e.preventDefault();
                        setPickerOpen((prevState) => ({
                          iconColorPink: !prevState.iconColorPink,
                          bgColorPink: false,
                        }));
                      }}
                    />
                    {pickerOpen?.iconColorPink && (
                      <ColorPickerWrapper
                        ref={pickerRef}
                        className="absolute mt-2 z-[9999]"
                      >
                        <ChromePicker
                          disableAlpha={true}
                          color={value?.iconColorCd}
                          onChange={(color) => {
                            setValue((prevState) => ({
                              ...prevState,
                              iconColorCd: color.hex,
                            }));
                          }}
                        />
                        <div className="mt-2">
                          <button
                            className=" w-[50%]   text-gray-700 py-1   transition duration-300"
                            onClick={(e) => {
                              e.preventDefault();

                              setValue((prevState) => ({
                                ...prevState,
                                iconColorCd:
                                  getUserInfoData?.color_cd || "#F7FAFC",
                              }));
                              setPickerOpen((prevState) => ({
                                ...prevState,
                                iconColorPink: false,
                              }));
                            }}
                          >
                            취소
                          </button>
                          <button
                            className=" w-[50%]   text-teal-500 py-1  transition duration-300"
                            onClick={(e) => {
                              e.preventDefault();
                              setPickerOpen((prevState) => ({
                                ...prevState,
                                iconColorPink: false,
                              }));
                            }}
                          >
                            완료
                          </button>
                        </div>
                      </ColorPickerWrapper>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

          {value?.franchisorYn === "Y" && (
            <div>
              <h2 className="font-bold mb-5 mt-5">
                프랜차이즈 서류를 업로드해 주세요.
              </h2>
              <div className="border-b border-gray-300 mb-7"></div>
              <div className="w-full flex sm:flex-row flex-col gap-x-10 gap-y-5 ">
                <div className="w-full">
                  <p className="mb-3 text-sm">
                    로고 <span className="text-teal-500">*</span>
                  </p>
                  <div className="relative img-wrap h-[150px]">
                    <input
                      type="file"
                      id="fileUpload4"
                      className="hidden"
                      accept="image/*"
                      ref={logoPhotoRef}
                      onChange={(event) => {
                        event.preventDefault();
                        handleUploadFile("logoPhoto", event.target.files);
                      }}
                    />
                    <label htmlFor="fileUpload4" className="block">
                      <div className="bg-[#F5F5F5] flex flex-col justify-center items-center rounded-[4px] h-[150px] text-center cursor-pointer">
                        {value.logoPhoto ? (
                          <div className="img flex items-center justify-center overflow-hidden">
                            <img
                              className="h-[-webkit-fill-available]"
                              src={value.logoPhoto}
                              alt="Upload file"
                            />
                            <div className="hover-wrapper">
                              <div className="upload-label">
                                <button
                                  type="button"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    logoPhotoRef.current.click();
                                  }}
                                >
                                  이미지 재업로드
                                </button>
                              </div>
                              <div
                                className="delete-label"
                                onClick={(event) => {
                                  event.preventDefault();
                                  handleDeleteFile("logoPhoto");
                                }}
                              >
                                <button type="button">이미지 삭제</button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-2">
                            <img src="./assets/plus.svg" alt="Upload file" />
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
                <div className="w-full">
                  <p className="mb-3 text-sm">
                    사업자등록증 <span className="text-teal-500">*</span>
                  </p>
                  <div className="relative img-wrap h-[150px]">
                    <input
                      type="file"
                      id="fileUpload3"
                      className="hidden"
                      accept="image/*"
                      ref={bizRegPhotoRef}
                      onChange={(event) => {
                        event.preventDefault();
                        handleUploadFile("bizRegPhoto", event.target.files);
                      }}
                    />
                    <label htmlFor="fileUpload3" className="block">
                      <div className="bg-[#F5F5F5] flex flex-col justify-center items-center rounded-[4px] h-[150px] text-center cursor-pointer">
                        {value.bizRegPhoto ? (
                          <div className="img flex items-center justify-center overflow-hidden">
                            <img
                              className="h-[-webkit-fill-available]"
                              src={value.bizRegPhoto}
                              alt="Upload file"
                            />
                            <div className="hover-wrapper">
                              <div className="upload-label">
                                <button
                                  type="button"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    bizRegPhotoRef.current.click();
                                  }}
                                >
                                  이미지 재업로드
                                </button>
                              </div>
                              <div
                                className="delete-label"
                                onClick={(event) => {
                                  event.preventDefault();
                                  handleDeleteFile("bizRegPhoto");
                                }}
                              >
                                <button type="button">이미지 삭제</button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-2">
                            <img src="./assets/plus.svg" alt="Upload file" />
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}

          <button
            type="submit"
            className="mt-10 w-full bg-teal-500 font-bold text-lg text-white py-3 rounded-[30px] hover:bg-teal-600 transition duration-300"
          >
            저장하기
          </button>
        </form>
      </div>

      {/*  문자인증 팝업  */}
      {modalOpen && (
        <form
          id="phoneForm"
          onSubmit={handlePhoneNum}
          className="fixed inset-0 z-50 overflow-y-auto bg-gray-500 bg-opacity-75 flex items-center justify-center"
        >
          <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[500px] w-full">
            <div className="bg-white py-5">
              <div className="mt-3 text-left">
                <div className="flex justify-between px-5">
                  <h3
                    className="text-base leading-6 font-extrabold"
                    id="modal-title"
                  >
                    휴대폰번호 재인증
                  </h3>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setValueCheck((prevState) => ({
                        ...prevState,
                        phoneNum: false,
                        certKey: false,
                      }));
                      setValue((prevState) => ({
                        ...prevState,
                        certNum: "",
                      }));
                      setPhone("");
                      setModalOpen(false);
                    }}
                  >
                    <img src="./assets/close.svg" />
                  </button>
                </div>
                <div className="border-b border-gray-300 my-5"></div>
                <div className="mt-2 px-5">
                  <label className="block text-sm mb-2">
                    전화번호 <span className="text-teal-500">*</span>
                  </label>
                  <div className="flex gap-x-[10px] mb-2">
                    <input
                      type="text"
                      placeholder="휴대폰번호"
                      maxLength="12"
                      value={phone}
                      onChange={(event) => {
                        numberOnly(event);
                        setValue((prevState) => ({
                          ...prevState,
                          certNum: "",
                        }));
                        setValueCheck((prevState) => ({
                          ...prevState,
                          phoneNum: false,
                          certKey: false,
                        }));
                        setPhone(event.target.value);
                      }}
                      className="text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
                    />
                    <button
                      type="button"
                      className={`w-40  text-white py-1.5 rounded-[10px] ${
                        valueCheck.phoneNum ? "bg-regal-blue" : "bg-teal-500"
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!phone) {
                          alert("휴대폰 번호를 입력해주세요");
                          return;
                        }

                        smsSendMutate(phone);
                      }}
                    >
                      인증번호 전송
                    </button>
                  </div>
                  <div className="flex gap-x-[10px]">
                    <input
                      type="text"
                      placeholder="인증번호 6자리를 입력해주세요"
                      maxLength="6"
                      value={value?.certNum}
                      onChange={(event) => {
                        numberOnly(event);
                        setValue((prevState) => ({
                          ...prevState,
                          certNum: event.target.value,
                        }));
                        setValueCheck((prevState) => ({
                          ...prevState,
                          certKey: false,
                        }));
                      }}
                      className="text-sm w-full px-3 h-9 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
                    />
                    <button
                      type="button"
                      className={`w-40  text-white py-1.5 rounded-[10px] ${
                        valueCheck.certKey ? "bg-regal-blue" : "bg-teal-500"
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!phone) {
                          alert("휴대폰 번호를 입력해주세요");
                          return;
                        }

                        if (!valueCheck.phoneNum) {
                          alert("휴대폰 번호를 인증해주세요");
                          return;
                        }
                        if (!value.certNum) {
                          alert("인증번호를 입력해주세요");
                          return;
                        }
                        if (value.certNum.length < 6) {
                          alert("인증번호를 확인해주세요");
                          return;
                        }

                        smsCertMutate({
                          phone_numb: phone,
                          cert_numb: value.certNum,
                        });
                      }}
                    >
                      인증하기
                    </button>
                  </div>
                  <div className="mt-[16px] float-right mb-5">
                    <button
                      type="button"
                      className={`w-12  text-[#1a202c] py-1.5 rounded-[10px] bg-[#edf2f7]  text-[14px]  `}
                      onClick={(e) => {
                        e.preventDefault();
                        setValueCheck((prevState) => ({
                          ...prevState,
                          phoneNum: false,
                          certKey: false,
                        }));
                        setValue((prevState) => ({
                          ...prevState,
                          certNum: "",
                        }));
                        setPhone("");
                        setModalOpen(false);
                      }}
                    >
                      취소
                    </button>
                    <button
                      type="submit"
                      className={`w-20  text-white py-1.5 rounded-[10px] bg-regal-blue  text-[14px]   ml-[17px]`}
                    >
                      인증 완료
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </main>
  );
};
const ColorPickerWrapper = styled.div`
  padding: 8px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 2px, rgba(0, 0, 0, 0.3) 0px 4px 8px;
  .chrome-picker {
    box-shadow: none !important;
  }
`;
export default Payment;
